import { render, staticRenderFns } from "./PartnerCostConfiguration.vue?vue&type=template&id=82775932&scoped=true&"
import script from "./PartnerCostConfiguration.vue?vue&type=script&lang=js&"
export * from "./PartnerCostConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCostConfiguration.vue?vue&type=style&index=0&id=82775932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82775932",
  null
  
)

export default component.exports